import React, { useEffect, useState } from 'react';
import  PageTitle from '../../Components/PageTitle';
import { images } from '../../assets/images';
import { Link, useLocation } from 'react-router-dom';
import ProductController from '../../apis/controller/ourProducts.controller';
import { renderImage } from '../../Components/helper/image';

function Productdetail(props) {
    const data = useLocation();
    const [productDetail, setProductdetail] = useState();
    const [loader, setLoader] = useState(false);
    useEffect(() => {
        getProductDetails();
		window.scrollTo(0, 0);
	}, []);


    const getProductDetails = async (id) => {
        setLoader(true);
        let res = await new ProductController().productsDetails(data.id);
        if (res && res.status) {
            setProductdetail(res);
        }
        setLoader(false);
    };
	return (
		<>
        {productDetail && productDetail.breadcrumbs ? <PageTitle title={productDetail.breadcrumbs.main_title} image={productDetail.breadcrumbs.image} />: null}
           {productDetail && productDetail.products && <div className='productdetail_wrap'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-xxl-12 col-12 col-lg-12 col-sm-12 col-12'>
                               <div className='productdetail_set'>
                                    <div className='left_area'>
                                        <h4>
                                            {productDetail.products.title}
                                        </h4>
                                        <p>
                                        {productDetail.products.description}
                                        </p>
                                     </div>
                                     <div className='right_area'>
                                          <div className='img_area'>
                                            <img src={renderImage(productDetail.products.image,'medium')} alt="..." className="img-fluid d-block mx-auto" />
                                          </div>
                                     </div>
                               </div>
                               {/* <div className='content'>
                                  <p>
                                    Quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irurin voluptate velit esse cillum dolore eu fugiat nulla pariatur. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irurin voluptate velit esse cillum dolore eu fugiat nulla pariatur. a commodo consequat. Duis aute irurin voluptate velit esse cillum dolore eu fugiat nulla pariatur. a commodo consequat. Duis aute irurin voluptate velit esse cillum dolore eu fugiat nulla pariatur. Quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irurin voluptate velit esse cillum dolore eu fugiat nulla pariatur. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irurin voluptate velit esse cillum dolore eu fugiat nulla pariatur. a commodo consequat. Duis aute irurin voluptate velit esse cillum dolore eu fugiat nulla pariatur. a commodo consequat. Duis aute irurin voluptate velit esse cillum dolore eu fugiat nulla pariatur.
                                  </p>
                                  <div className='list'>
                                    <ul>
                                        <li>
                                            Quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. 
                                        </li>
                                        <li>
                                            Duis aute irurin voluptate velit esse cillum dolore eu fugiat nulla pariatur.
                                        </li>
                                        <li>
                                            Quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. 
                                        </li>
                                        <li>
                                            Duis aute irurin voluptate velit esse cillum dolore eu fugiat nulla pariatur.
                                        </li>
                                    </ul>
                                  </div>
                                  <p>
                                    Quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irurin voluptate velit esse cillum dolore eu fugiat nulla pariatur. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irurin voluptate velit esse cillum dolore eu fugiat nulla pariatur. a commodo consequat. Duis aute irurin voluptate velit esse cillum dolore eu fugiat nulla pariatur. a commodo consequat. Duis aute irurin voluptate velit esse cillum dolore eu fugiat nulla pariatur. Quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irurin voluptate velit esse cillum dolore eu fugiat nulla pariatur. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irurin voluptate velit esse cillum dolore eu fugiat nulla pariatur. a commodo consequat. Duis aute irurin voluptate velit esse cillum dolore eu fugiat nulla pariatur. a commodo consequat. Duis aute irurin voluptate velit esse cillum dolore eu fugiat nulla pariatur.
                                  </p>
                               </div> */}
                        </div>
                    </div>
                </div>
            </div>}
            <div className='grow_business_set'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-xxl-12 col-12 col-lg-12 col-sm-12 col-12'>
                            <div className='grow_business'>
                                <div className="left">
                                    <h3>
                                        Grow Your Business and Build Your Website or Software With us.
                                    </h3>
                                </div>
                                <div className="right">
                                    <Link to="" className="btn-primary_set">Contact Us</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
		</>
	);
}

export default Productdetail;